import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const ButtonLink = styled.a`
    font-size: ${theme.font.size14};
    color: ${(props) => props.theme.orangeLink};
    font-weight: 600;
    text-decoration: underline;
`;
